/* <span class="label tenant-count"><span class="progress-count">2</span><span class="total-count">/2</span>    </span> */
import * as React from "react";
import styles = require("./style.less");
import * as cn from "classnames";

interface TenantDeploymentCountProps {
    expected: number;
    progress: number;
}

const TenantDeploymentCount: React.StatelessComponent<TenantDeploymentCountProps> = props => {
    return <span className={styles.container}><span className={styles.progress}>{props.progress}</span><span  className={styles.expected}>/{props.expected}</span>    </span>;
};

export default TenantDeploymentCount;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/ProjectDashboard/TenantDeploymentCount/index.tsx